import * as React from "react";
import css from "./FanReviews.module.css";

const fanReviews = [
  {
    text: "My print from Maggie just arrived today, thank you so much because you make my Friday much better",
  },
  {
    text: "I wish I knew about your community sooner. This is so fantastic. I love that this exists even for charity. Best of all worlds.",
  },
  {
    text: "My granddaughter received her beautiful picture she was waiting for she was very happy",
  },
];

export default function FanReviews() {
  return (
    <div className={css.wrapper}>
      <section className={css.section}>
        <h2 className={css.heading}>What Fans Are Saying</h2>

        <div className={css.grid}>
          {fanReviews.map(({ text }) => (
            <blockquote className={css.card} key={text}>
              <span className={css.quoteMark} aria-hidden="true">
                &ldquo;
              </span>
              <p className={css.quote}>{text}</p>
            </blockquote>
          ))}
        </div>
      </section>
    </div>
  );
}
